import { list } from './list-country-lang';
function isNullOrUndefined(value) {
  return typeof value === 'undefined' || value === null;
}
function getDefaultCountry(isUpperCase) {
  const defaultCountry = list[0].country;
  return isUpperCase ? defaultCountry.toUpperCase() : defaultCountry.toLowerCase();
}
function getExistOrDefaultLanguage(language) {
  const languages = list[0].language;
  return languages.includes(language) ? language : languages[0];
}
const validate = (country, language) => {
  const result = { country, language };
  const COUNTRY = isNullOrUndefined(country) ? 'NO COUNTRY' : country.toUpperCase();
  const countryLanguages = list.find((countryLanguage) => countryLanguage.country === COUNTRY);
  if (countryLanguages) {
    if (!countryLanguages.language.includes(language)) {
      result.language = countryLanguages.language[0];
    }
  }
  else {
    result.country = getDefaultCountry(country === COUNTRY);
    result.language = getExistOrDefaultLanguage(language);
  }
  return result;
};
export default validate;
